// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vendor-services__header[data-v-379bc2a4]{display:block}.vendor-services[data-v-379bc2a4] .venue-selector-wrapper .venue-selector{padding-bottom:unset}.vendor-services[data-v-379bc2a4] .venue-selector-wrapper .venue-selector__select::v-deep{width:auto}", ""]);
// Exports
module.exports = exports;
